export default {
    title: "Pregled korisnika",
    backToLink: {
        text: "Nazad na ",
        section: "uloge i korisnike"
    },
    fullName: "Ime i prezime",
    email: "Email",
    roles: "Uloge",
    button: {
        save: "Sačuvaj",
        back: "Nazad",
        edit: "Izmijeni"
    },

    showUser: {
        title: "Uloge i korisnici",
        tabs: {
            roles: "Uloge",
            users: "Korisnici"
        },
        addUser: "Dodaj korisnika",
        search: "Pretraži email",
        deleteUser: "Izbriši",
        table: {
            username: "Korisničko ime",
            email: "Email",
            roles: "Uloge"
        }
    }
}
